import styled from 'styled-components'

export const StatusWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`

export const StatusCircle = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  display: inline-block;
`
